/** 익사 위험 시 게이트웨이 HLS 증거 영상 보관 (전역) */

export interface RiskRecordingSettings {
  enabled: boolean;
  pre_seconds: number;
  post_seconds: number;
}

export const DEFAULT_RISK_RECORDING_SETTINGS: RiskRecordingSettings = {
  enabled: true,
  pre_seconds: 15,
  post_seconds: 15,
};

export function mergeRiskRecordingSettings(
  partial?: Partial<RiskRecordingSettings> | null
): RiskRecordingSettings {
  const p = partial || {};
  const d = DEFAULT_RISK_RECORDING_SETTINGS;
  const num = (v: unknown, fallback: number) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  };
  const bool = (v: unknown, fallback: boolean) => {
    if (typeof v === 'boolean') return v;
    if (v === 'true' || v === '1') return true;
    if (v === 'false' || v === '0') return false;
    return fallback;
  };
  return {
    enabled: bool(p.enabled, d.enabled),
    pre_seconds: Math.min(120, Math.max(1, Math.floor(num(p.pre_seconds, d.pre_seconds)))),
    post_seconds: Math.min(120, Math.max(1, Math.floor(num(p.post_seconds, d.post_seconds)))),
  };
}

/** 시스템 관리에 저장된 위험 녹화(pre/post) 설정 */
export async function fetchRiskRecordingSettingsFromSystem(): Promise<RiskRecordingSettings> {
  const api = (await import('../services/api')).default;
  const data = await api.get<{ risk_recording?: Partial<RiskRecordingSettings> }>(
    '/api/settings/system'
  );
  return mergeRiskRecordingSettings(data?.risk_recording);
}
